var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconbrowserpopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 64,
    viewBox: "0 0 52 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 45H29V59C29 60.6569 27.6569 62 26 62C24.3431 62 23 60.6569 23 59V45Z",
    fill: "#041733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47.6654C14.0338 47.6654 4.33333 37.9648 4.33333 25.9987C4.33333 14.0325 14.0338 4.33203 26 4.33203C37.9661 4.33203 47.6667 14.0325 47.6667 25.9987C47.6667 37.9648 37.9661 47.6654 26 47.6654ZM23.8333 32.4987V36.832H28.1667V32.4987H23.8333ZM23.8333 15.1654V28.1654H28.1667V15.1654H23.8333Z",
    fill: "#1271FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 19,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconbrowserpopup);
export default __webpack_public_path__ + "static/media/icon.browser.popup.d803fdb6cca5553cbb753c9ac419d130.svg";
export { ForwardRef as ReactComponent };